import { HTTP } from '../http'

export const GROUP_API = {
  unregisterGroup: async (url, groupId, sessionId, modality, profile = '') => {
    return HTTP.delete(
      url + modality.getRegisterEndpoint(profile, groupId),
      {
        headers: {
          'X-Session-ID': sessionId
        }
      }
    )
  },
  checkRegisterStatusGroup: async (url, groupId, sessionId, modality, profile = '') => {
    return HTTP.get(
      url + modality.getRegisterEndpoint(profile, groupId),
      {
        headers: {
          'X-Session-ID': sessionId
        }
      }
    )
  },
  registerGroup: async (url, groupId, sessionId, modality, profile = '') => {
    return HTTP.post(
      url + modality.getRegisterEndpoint(profile, groupId),
      {},
      {
        headers: {
          'X-Session-ID': sessionId
        }
      }
    )
  },
  getGroups: async (url, sessionId) => {
    return HTTP.get(
      url + 'group',
      {
        headers: {
          'X-Session-ID': sessionId
        }
      }
    )
  },
  createGroup: async (url, data, sessionId) => {
    return HTTP.post(
      url + 'group',
      data,
      {
        headers: {
          'X-Session-ID': sessionId
        }
      }
    )
  },
  getGroupsWithPerson: async (url, personId, sessionId) => {
    return HTTP.get(
      url + 'group/groups/' + encodeURIComponent(personId),
      {
        headers: {
          'X-Session-ID': sessionId
        }
      }
    )
  },
  deleteGroup: async (url, groupId, sessionId) => {
    return HTTP.delete(
      url + 'group/' + groupId,
      {
        headers: {
          'X-Session-ID': sessionId
        }
      }
    )
  },
  checkGroupActivity: async (url, groupId, sessionId) => {
    return HTTP.get(
      url + 'group/' + groupId,
      {
        headers: {
          'X-Session-ID': sessionId
        }
      }
    )
  },
  getGroupPersons: async (url, groupId, sessionId) => {
    return HTTP.get(
      url + 'group/' + groupId + '/person',
      {
        headers: {
          'X-Session-ID': sessionId
        }
      }
    )
  },
  getGroupPersonsPage: async (url, groupId, params, sessionId) => {
    return HTTP.get(
      url + 'group/' + groupId + '/person/page',
      {
        params,
        headers: {
          'X-Session-ID': sessionId
        }
      }
    )
  },
  deletePersonFromGroup: async (url, groupId, personId, sessionId) => {
    return HTTP.delete(
      url + 'group/' + groupId + '/person/' + encodeURIComponent(personId),
      {
        headers: {
          'X-Session-ID': sessionId
        }
      }
    )
  },
  addPersonToGroup: async (url, groupId, personId, sessionId) => {
    return HTTP.post(
      url + 'group/' + groupId + '/person/' + encodeURIComponent(personId),
      {},
      {
        headers: {
          'X-Session-ID': sessionId
        }
      }
    )
  },
  deletePersonsFromGroup: async (url, groupId, data, sessionId) => {
    return HTTP.delete(
      url + 'group/' + groupId + '/persons',
      {
        data,
        headers: {
          'X-Session-ID': sessionId
        }
      }
    )
  },
  addPersonsToGroup: async (url, groupId, body, sessionId) => {
    return HTTP.post(
      url + 'group/' + groupId + '/persons',
      body,
      {
        headers: {
          'X-Session-ID': sessionId
        }
      }
    )
  },
  getPersons: async (url, sessionId) => {
    return HTTP.get(
      url + 'person',
      {
        headers: {
          'X-Session-ID': sessionId
        }
      }
    )
  },
  getPersonsPage: async (url, params, sessionId) => {
    return HTTP.get(
      url + 'person/page',
      {
        params,
        headers: {
          'X-Session-ID': sessionId
        }
      }
    )
  }
}
